export const TEST_IDS = {
    APPLICATION_NAME_FIELD: "application-name-field",
    CREATE_APPLICATION: "create-application",
};
